import { render, staticRenderFns } from "./DropdownSortNewOld.vue?vue&type=template&id=aaa4ed64&scoped=true"
import script from "./DropdownSortNewOld.vue?vue&type=script&lang=js"
export * from "./DropdownSortNewOld.vue?vue&type=script&lang=js"
import style0 from "./DropdownSortNewOld.vue?vue&type=style&index=0&id=aaa4ed64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa4ed64",
  null
  
)

export default component.exports